import { ApiError } from "@kontextwerk/web-common";

export type ErrorKind =
  | "auth"
  | "forbidden"
  | "validation"
  | "conflict"
  | "notfound"
  | "server"
  | "unknown";

export interface DescribedError {
  status: number;
  kind: ErrorKind;
  message: string;
  /** Structured `detail` when the server sent one (see `ApiError.detail`). */
  detail?: unknown;
}

const KIND_BY_STATUS: Record<number, ErrorKind> = {
  401: "auth",
  403: "forbidden",
  404: "notfound",
  409: "conflict",
  422: "validation",
};

export function describeApiError(e: unknown): DescribedError {
  if (e instanceof ApiError) {
    const kind =
      KIND_BY_STATUS[e.status] ?? (e.status >= 500 ? "server" : e.status >= 400 ? "validation" : "unknown");
    return { status: e.status, kind, message: e.message, detail: e.detail };
  }
  if (e instanceof Error) return { status: 0, kind: "unknown", message: e.message };
  return { status: 0, kind: "unknown", message: String(e) };
}
